















































    import {Component, Vue, Watch, Prop, Emit} from 'vue-property-decorator';
    import DataTable from '@/components/common/Tables/DataTable.vue';
    import Snackbar from "@/components/common/Snackbar.vue";
    import Navbar from '@/components/common/Navbar.vue';
    import MTStockEditRequestService from "@/services/MTStockEditRequestService";
    import {IOpeningStockEditItems, IOpeningStockRequestManager, IRequestActionParams} from '@/interfaces/RequestManager';
    import { ITableHeader} from '@/interfaces/common';
    import moment from 'moment'
    Vue.prototype.moment = moment
    @Component({
        components:{
            DataTable,
            Snackbar,
            Navbar
        }       
    })
export default class TertiaryEditRequestEditItem extends Vue {
    @Prop() readonly ItemDetails!:any;
    @Prop() toView!:boolean;
    @Prop() requestDetails!:IRequestActionParams;
    @Prop() readonly requestInfo!:string;
    @Prop() toArchived!:boolean;
    private snackBarMessage: string = "";
    private snackbar: boolean = false;
    private snackColor: string = "red";
    // private editItems:Array<IOpeningStockEditItems>=[];
    private tableHeaders:Array<ITableHeader>=[
        {
            text:'SKU Name', 
            value:'productName',
            sortable:true,
            default:'-'
        },
        {
            text:'Tertiary (Old)',
            value:'TertiaryOld',
            sortable:false,
            default:'-'
        },
        {
            text:'Tertiary (New)',
            value:'TertiaryNew',
            sortable:false,
            default:'-'
        },
    ]
    @Emit('navigate')
    navigate(){
        return;
    }
    private loading1:boolean=false;
    private loading2:boolean=false;
    @Emit('approveRequest')
    approveRequest(item:IRequestActionParams)
    {
        this.loading1=true;
        return
        // var Id=item.Id;
        // var status=1;
        // MTStockEditRequestService.ReviewRequest(Id,status).then((res)=>{
        //   this.n=1;  
        // })
        // .catch((err)=>{
        //     console.log(err);
        // })
        
    }
    @Emit('rejectRequest')
    rejectRequest(item:IRequestActionParams)
    {
        this.loading2=true;
        return;
        
    }
}
